// STYLES
import "../scss/minicomponents/download.scss";
import "../scss/index.scss";
import "../scss/global.scss";
// FONT AWESOME
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
const awsDownload = <FontAwesomeIcon icon={faDownload} />;
const Download = () => {
  return (
    <div className="download">
      <h3>Download classic resume</h3>
      <button>{awsDownload} Download</button>
    </div>
  );
};

export default Download;
